import React, { useState, useEffect, useRef } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CardContent } from '@mui/material';



export const ProductsSlider = ({ data }) => {
  const router = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  const [transitionEnabled, setTransitionEnabled] = useState()

  const getResponsiveSlidesToShow = () => {
    const width = window.innerWidth;
    if (width < 768) return 1;
    if (width < 1024) return 1;
    return 8;
  };
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(getResponsiveSlidesToShow());
  const canSlide = data.length > slidesToShow -1;

  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(getResponsiveSlidesToShow());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % data.length);
  };

  const handlePrevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + data.length) % data.length);
  };

  const visibleSlides = [];

  if (canSlide) {
    for (let i = 0; i < slidesToShow; i++) {
      const index = (currentIndex + i) % data.length;
      visibleSlides.push(data[index]);
    }
  } else {
    visibleSlides.push(...data); // just show all
  }



  useEffect(() => {
    if (!transitionEnabled) {
      const timer = setTimeout(() => setTransitionEnabled(true), 50);
      return () => clearTimeout(timer);
    }
  }, [transitionEnabled]);




  // Slider container styles
  const sliderContainerStyle = {
    position: 'relative',
    // overflowX: 'hidden',
    padding: '10px',
    // margin: '0 30px'
  };



  const productCardStyle = {
    backgroundColor: "#fff",
    borderRadius: '5px',
    overflow: 'hidden',
    cursor: 'pointer',
    width: '100px'
  };

  const navButtonStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    boxShadow: '0 0 10px #00000057',
    background: '#00000033',
    color: 'white',
    border: 'none',
    padding: '5px',
    zIndex: 10,
    cursor: 'pointer',
    borderRadius: '50%',
  };

  return (
    <div className='recommendd'>
      <div style={sliderContainerStyle}>
        {data.length > slidesToShow-1 && <button
          onClick={handlePrevSlide}
          style={{ ...navButtonStyle, left: 0 }}
          className='slider-btn'
        >
          <ChevronLeftIcon />
        </button>}

        {data.length > slidesToShow-1 && <button
          onClick={handleNextSlide}
          style={{ ...navButtonStyle, right: "0%" }}
          className='slider-btn'
        >
          <ChevronRightIcon />
        </button>}

        <div style={{
          overflowX: "hidden",
          margin: "0 30px"
        }}
        >
          {/* <div ref={sliderRef} style={sliderTrackStyle} onTransitionEnd={handleTransitionEnd}> */}
          <div style={{
    display: 'flex',
    transition: 'transform 0.5s ease',
    width: '100%',
  }}>
            {visibleSlides?.map((val, index) => (
                <div key={`${val._id}-${index}`} style={{
                  flex: `0 0 ${100 / slidesToShow}%`,
                  padding: '0 10px',
                  boxSizing: 'border-box'
                }} onClick={() => window.open(`${process.env.REACT_APP_PRODUCT_URL}?id=${val._id}`,'_blank')}>
                <div
                  style={productCardStyle}

                >
                  <div style={{
                    position: 'relative',
                  }}>
                    <img
                      src={val?.productImages[0]}
                      alt={`thumbnail-${index}`}
                      style={{
                        width: '100%',
                        height: '60px',
                        objectFit: 'cover'
                      }}
                    />

                  </div>

                  <div className='px-2 py-2'>
                    <Typography variant="h6" fontWeight="bold" sx={{ color: '#1976d2' }} className='product-sub-title'>
                      {val?.title}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                      <Typography variant="h5" fontWeight="bold" className='product-price m-0'>
                      {
                          val?.type === "simple"
                            ? (val?.discountPrice === 0
                              ? `$${val?.price.toFixed(2)}`
                              : `$${val?.discountPrice?.toFixed(2) || val?.price?.toFixed(2)}`)
                            : (val?.variants?.discountPrice === 0
                              ? `$${val?.variants?.price.toFixed(2)}`
                              : `$${val?.variants?.discountPrice?.toFixed(2) || val?.variants?.price?.toFixed(2)}`)
                        }
                      </Typography>

                      {(val?.type === "simple" && val?.discountPrice > 0) ||
                        (val?.type !== "simple" && val?.variants?.discountPrice > 0) ? (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ textDecoration: 'line-through' }}
                        >
                          {val.type === "simple" ? val?.price : val?.variants?.price}
                        </Typography>
                      ) : null}
                    </Box>

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default ProductsSlider;


// "use client";

// import React, { useState, useEffect, useRef } from 'react';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import { useNavigate } from 'react-router-dom';
// import { Box, Typography, CardContent } from '@mui/material';



// export const ProductsSlider = ({ data }) => {
//   const router = useNavigate();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const sliderRef = useRef(null);
  
//   // Configuration
//   const slidesToShow = 7;
//   const slidesToScroll = 1;
//   const autoplaySpeed = 3000;

//   // Responsive breakpoints
//   const getResponsiveSlidesToShow = () => {
//     const width = window.innerWidth;
//     if (width < 768) return 1;
//     if (width < 1024) return 2;
//     return 8;
//   };

//   // Auto-slide logic
// //   useEffect(() => {
// //     const autoSlideInterval = setInterval(() => {
// //       handleNextSlide();
// //     }, autoplaySpeed);

// //     return () => clearInterval(autoSlideInterval);
// //   }, [currentSlide]);

//   // Slide navigation functions
//   const handleNextSlide = () => {
//     const totalSlides = Math.ceil(data?.length / slidesToScroll);
//     setCurrentSlide((prev) => (prev + 1) % totalSlides);
//   };

//   const handlePrevSlide = () => {
//     const totalSlides = Math.ceil(data?.length / slidesToScroll);
//     setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
//   };

//   // Slider container styles
//   const sliderContainerStyle= {
//     position: 'relative',
//     // overflowX: 'hidden',
//     padding: '10px',
//     // margin: '0 30px'
//   };

//   // Slider track styles (for sliding)
//   const sliderTrackStyle = {
//     display: 'flex',
//     transition: 'transform 0.5s ease',
//     transform: `translateX(-${currentSlide * (100 / getResponsiveSlidesToShow())}%)`,
//     // width: '1265px',
//     // margin: '0 auto',
//   };

//   // Slide item styles
//   const slideItemStyle = {
//     flex: `0 0 ${100 / getResponsiveSlidesToShow()}%`,
//     padding: '0 10px',
//     boxSizing: 'border-box',
//   };

//   // Product card styles
//   const productCardStyle = {
//     // border: '1px solid #ddd',
//     backgroundColor: "#fff",
//     borderRadius: '5px',
//     overflow: 'hidden',
//     // boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
//     cursor: 'pointer',
//     width: '100px'
//   };

//   // Navigation button styles
//   const navButtonStyle = {
//     position: 'absolute',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     // background: 'rgba(0,0,0,0.5)',
//     boxShadow: '0 0 10px #00000057',
//     background: '#00000033',
//     color: 'white',
//     border: 'none',
//     padding: '5px',
//     zIndex: 10,
//     cursor: 'pointer',
//     borderRadius: '50%',
//   };

//   return (
//     <div className='recommendd'>
//     <div style={sliderContainerStyle}>
//       {/* Previous Slide Button */}
//       { data.length > 8 && <button 
//         onClick={handlePrevSlide} 
//         style={{...navButtonStyle, left: 0}}
//         className='slider-btn'
//       >
//       <ChevronLeftIcon />
//       </button>}

//       {/* Next Slide Button */}
//       { data.length > 8 && <button 
//         onClick={handleNextSlide} 
//         style={{...navButtonStyle, right: "0%"}}
//         className='slider-btn'
//       >
//         <ChevronRightIcon />
//       </button>}

//       {/* Slider Track */}
//       <div style={{
//         overflowX: "hidden",
//         margin: "0 30px"
//       }}
//       >
//         <div ref={sliderRef} style={sliderTrackStyle}>
//           {data?.map((val, index) => (
//             <div key={val._id} style={slideItemStyle}>
//               <div 
//                 style={productCardStyle}
                
//               >
//                 {/* Product Image */}
//                 <div style={{ 
//                   position: 'relative', 
//                 //   paddingTop: '56.25%', 
//                 //   overflow: 'hidden' 
//                 }}>
//                   <img 
//                     src={val?.productImages[0]} 
//                     alt={`thumbnail-${index}`}
//                     style={{
//                     //   position: 'absolute',
//                     //   top: 0,
//                     //   left: 0,
//                       width: '100%',
//                       height: '60px',
//                       objectFit: 'cover'
//                     }}
//                   />
//                   {/* Price Badge
//                   <span style={{
//                     position: 'absolute',
//                     top: '8px',
//                     right: '8px',
//                     background: 'white',
//                     color: 'black',
//                     padding: '4px 8px',
//                     borderRadius: '50px',
//                     fontSize: '12px',
//                     fontWeight: 'bold'
//                   }}>
//                     ${val?.discountPrice || val?.price}
//                   </span> */}
//                 </div>

//                 {/* Product Info */}
//                 {/* <CardContent className='px-2 py-2'> */}
//                 <div className='px-2 py-2'>
//                 <Typography variant="h6" fontWeight="bold" sx={{ color: '#1976d2' }} className='product-sub-title'>
//                     title
//                 </Typography>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                     <Typography variant="h5"  fontWeight="bold" className='product-price m-0'>
//                         $ 3542
//                     </Typography>
                  
//                         <Typography variant="body2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
//                            $425
//                         </Typography>
                   
//                 </Box>
//                 </div>
//                 {/* <CardContent /> */}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       {/* Dots Indicator */}
//       { data.length > 8 && <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         marginTop: '10px'
//       }}>
//         {Array.from({ length: Math.ceil(data.length / slidesToScroll) }).map((_, index) => (
//           <span 
//             key={index} 
//             style={{
//               height: '10px',
//               width: '10px',
//               borderRadius: '50%',
//               background: index === currentSlide ? '#000' : '#ddd',
//               margin: '0 5px',
//               cursor: 'pointer'
//             }}
//             onClick={() => setCurrentSlide(index)}
//           />
//         ))}
//       </div>}
//     </div>
//     </div>
//   );
// };

// export default ProductsSlider;